import { IRequestSender } from '@studyportals/mb-platform-http-requests';
import { SuperAgentRequest, Response } from 'superagent';
import { RetryWithBackoff } from '@/platform/core/RetryWithBackoff';

export class RequestSenderDecoratorReflectorRetry implements IRequestSender {
	private readonly target: IRequestSender;

	private readonly retryWithBackoff = new RetryWithBackoff(10, 500);

	public constructor(target: IRequestSender) {
		this.target = target;
	}

	public async send(request: SuperAgentRequest): Promise<Response> {
		if (request.method === 'PUT') {
			return await this.target.send(request);
		} else {
			return await this.retryWithBackoff.execute(
				async () => await this.target.send(request),
			);
		}
	}

	public async sendAndExtractBody<T>(request: SuperAgentRequest): Promise<T> {
		if (request.method === 'PUT') {
			return await this.target.sendAndExtractBody<T>(request);
		} else {
			return await this.retryWithBackoff.execute(
				async () => await this.target.sendAndExtractBody<T>(request),
			);
		}
	}
}
